import { graphql } from 'react-relay';

export const configurableBlockListQuery = graphql`
	query configurableBlockPages_list_Query {
		viewer {
			...ConfigurableBlockList_viewer
		}
	}
`;

export const configurableBlockAddQuery = graphql`
	query configurableBlockPages_add_Query {
		viewer {
			...ArticleSelector_viewer
		}
	}
`;

export const configurableBlockEditQuery = graphql`
	query configurableBlockPages_edit_Query($id: ID!) {
		viewer {
			...ConfigurableBlockEdit_viewer @arguments(id: $id)
		}
	}
`;



// WEBPACK FOOTER //
// src/components/configurable-blocks/configurable-block-pages.js